import { breadcrumbScript } from "@/lib/seo-jsonld";
import { createFileRoute } from "@tanstack/react-router";

const sections = [
  ["Ümumi qaydalar", "Albazar.az saytından istifadə etməklə siz bu şərtləri qəbul etmiş sayılırsınız."],
  ["Elan yerləşdirmə", "Elanlar real və dəqiq məlumat əks etdirməlidir. Saxta, təkrarlanan və qanunsuz məhsul elanları silinir."],
  ["Qadağan olunan məzmun", "Silah, narkotik, saxta sənəd, oğurluq mal və digər qanunsuz məhsulların satışı qadağandır."],
  ["Ödənişli xidmətlər", "VIP və Premium paketlər ödənişlidir, təsdiqləndikdən sonra geri qaytarılmır."],
  ["Məsuliyyət", "Sayt alıcı və satıcı arasındakı əməliyyatlara görə məsuliyyət daşımır. Ehtiyatlı olun və görüşü təhlükəsiz yerdə keçirin."],
];

export const Route = createFileRoute("/sertler")({
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { title: "İstifadə şərtləri — Albazar.az" },
      { name: "description", content: "Albazar.az saytından istifadə qaydaları, elan yerləşdirmə şərtləri və qadağalar." },
      { property: "og:title", content: "İstifadə şərtləri — Albazar.az" },
      { property: "og:description", content: "Saytdan istifadə qaydaları." },
    
      { property: "og:url", content: "https://albazar.az/sertler" },
    ],
    links: [{ rel: "canonical", href: "https://albazar.az/sertler" }],
    scripts: [breadcrumbScript([{ name: "İstifadə şərtləri", path: "/sertler" }])],
  }),
  component: () => (
    <div className="container-x max-w-3xl py-12">
      <h1 className="text-4xl font-extrabold tracking-tight">İstifadə şərtləri</h1>
      <div className="mt-8 space-y-6">
        {sections.map(([t, d]) => (
          <section key={t}>
            <h2 className="text-lg font-bold">{t}</h2>
            <p className="mt-2 leading-relaxed text-muted-foreground">{d}</p>
          </section>
        ))}
      </div>
    </div>
  ),
});